import { mutatorAction } from 'satcheljs';
import getStore from '../store/store';
export default mutatorAction('SET_NEW_MAIL_TOAST_ENABLED', function (isEnabled) {
    getStore().newMailToast = isEnabled;
});
//# sourceMappingURL=setNewMailToastEnabled.js.map